/**
 * Normalizes a URL by ensuring it has an http or https protocol.
 * If no protocol is provided, defaults to https://
 * 
 * @param url - The URL to normalize
 * @returns The normalized URL with protocol
 * 
 * @example
 * normalizeUrl('www.google.com') // returns 'https://www.google.com'
 * normalizeUrl('google.com') // returns 'https://google.com'
 * normalizeUrl('https://google.com') // returns 'https://google.com'
 * normalizeUrl('http://google.com') // returns 'http://google.com'
 */
export const normalizeUrl = (url: string): string => {
  if (!url) return url;
  
  // Check if URL already has http or https protocol
  if (url.match(/^https?:\/\//i)) {
    return url;
  }
  
  // Default to https:// if no protocol is provided
  return `https://${url}`;
};
